"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./LineItem.scss");
var utils_1 = require("@idp/ui-components/utils");
var ui_components_1 = require("@idp/ui-components");
var EditAndRemove_1 = require("../EditAndRemove");
var LineItem = /** @class */ (function (_super) {
    __extends(LineItem, _super);
    function LineItem(props) {
        var _this = _super.call(this, props) || this;
        _this.showDeliveryDate = false;
        _this.showEditAndRemove = _this.showEditAndRemove.bind(_this);
        _this.showPrice = _this.showPrice.bind(_this);
        _this.editItem = _this.editItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        _this.showContent = _this.showContent.bind(_this);
        return _this;
    }
    LineItem.prototype.render = function () {
        if (this.props && this.props.data && this.props.data.showLineItem) {
            return (React.createElement("div", { className: styles.itemContainer },
                this.props.data && this.props.data.showImage &&
                    React.createElement("section", { className: styles.imageSection },
                        React.createElement("img", { className: styles.deviceImg, src: this.props.data.imageUrl, alt: this.props.data.altText })),
                React.createElement("section", { className: styles.contentSection },
                    React.createElement("div", { className: styles.lineItemInfo },
                        this.props.data.headingText &&
                            React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: this.props.data.headingText }, options: { className: styles.headingText }, testId: utils_1.default('WRLS', 'Device', 'heading') }),
                        this.showContent(),
                        this.showDeliveryDate && React.createElement("div", { className: styles.deliveryDate })),
                    React.createElement("div", null,
                        this.showPrice(),
                        this.props.options && this.props.options.removeInfo &&
                            this.props.options.removeInfo.showEditAndRemove && this.showEditAndRemove(true)))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    LineItem.prototype.showEditAndRemove = function (showEditAndRemove) {
        return (React.createElement("div", null, showEditAndRemove &&
            React.createElement(EditAndRemove_1.default, { data: {}, options: { ariaLabelEdit: this.props.data.altText,
                    ariaLabelRemove: this.props.data.altText, isIconsMode: true }, events: { onItemEdit: this.editItem, onItemRemove: this.removeItem } })));
    };
    LineItem.prototype.showContent = function () {
        if (this.props.data && this.props.data.deviceDetails &&
            (this.props.data.showImage || this.props.data.itemName)) {
            return (React.createElement("div", null,
                React.createElement("span", { className: styles.itemname }, this.props.data.deviceDetails)));
        }
        else if (this.props.data && this.props.data.deviceDetails && !this.props.data.showImage) {
            return (React.createElement("div", null,
                React.createElement("span", { className: styles.lineItemContent }, this.props.data.deviceDetails)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    LineItem.prototype.showPrice = function () {
        if (this.props.data && this.props.data.itemPriceInfo) {
            return (React.createElement("div", { className: styles.lineItemPrice }, this.props.data.itemPriceInfo));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    LineItem.prototype.editItem = function () {
        if (this.props && this.props.events && this.props.events.onItemEdit &&
            this.props.options && this.props.options.editUrl) {
            this.props.events.onItemEdit(this.props.options.editUrl);
        }
    };
    LineItem.prototype.removeItem = function () {
        if (this.props && this.props.events && this.props.events.onItemRemove &&
            this.props.options && this.props.options.removeInfo && this.props.options.removeInfo.losgInfo) {
            var losgId = this.props.options.removeInfo.losgInfo.id || '';
            var lineItem = this.props.options.removeInfo.lineItem;
            var losg = this.props.options.removeInfo.losgInfo;
            this.props.events.onItemRemove(losgId, lineItem, losg, '', this.props.options.removeInfo.losgsCount);
        }
    };
    return LineItem;
}(React.Component));
exports.default = LineItem;
//# sourceMappingURL=LineItem.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/LineItem/LineItem.js
// module id = 2310
// module chunks = 8